import { ModalContainerProps} from '@ngw6/us-components';
import React from 'react';
import {useFeatureServices} from '../../hooks/use-feature-services';
import { ModalTrimModuleDetailsTranslations} from '../../typing/translations';
import { Dealer } from '../../typing/model';
import { Offer } from '../../typing/offer';
import ModalTrimModuleDetails from '../modal-trim-module-details';
import { FocusLayerSizeV2} from '@volkswagen-onehub/layer-manager';
import { ModelConfig } from '../../typing/main';

interface ModalWithLayerProps extends ModalContainerProps {
  translations: ModalTrimModuleDetailsTranslations;
  dealer?: Dealer;
  offer?: Offer;
  model?: ModelConfig;
  onLoadHandler?: () => void;
}

const ModalWithLayer: React.FC<ModalWithLayerProps> = (
  props,
) => {
  const {active, dealer, translations, onCloseHandler,onLoadHandler, offer, model} = props;
  const layerManager = useFeatureServices()['layer-manager'];
  React.useEffect(() => {
    if (active) {
      layerManager.openFocusLayer(
        ModalTrimModuleDetails,
        {
          text: ' layer',
          index: 3,
          dealer,
          translations,
          onCloseHandler,
          offer,
          model,
          active
        },
        {
          onClose: onCloseHandler,
          size: FocusLayerSizeV2.C
        },
      );
      onLoadHandler && onLoadHandler();
    }
    return () => {};
  }, [active]);

  return <div></div>;
};

export default ModalWithLayer;
